import { render, staticRenderFns } from "./PriceComparisonModal.vue?vue&type=template&id=d9053e2c&scoped=true"
import script from "./PriceComparisonModal.vue?vue&type=script&lang=js"
export * from "./PriceComparisonModal.vue?vue&type=script&lang=js"
import style0 from "./PriceComparisonModal.vue?vue&type=style&index=0&id=d9053e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9053e2c",
  null
  
)

export default component.exports